/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, dialogPolyfill, document, location, navigator, window */

blacksunplc.events.ready(function () {
    'use strict';

    var arrays = blacksunplc.arrays; // import * as arrays    from "module:blacksunplc/arrays"

    const sections = document.querySelectorAll('body > main > section:not(.what-we-do, .OF-section3)');
    const footer = document.querySelector('footer.main-footer');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-active');
                } else {
                    entry.target.classList.remove('is-active');
                }
            });
        },
        {
            threshold: 0.01,
        }
    );

    sections.forEach((section) => observer.observe(section));
    if (footer) observer.observe(footer);

    // Control global star background visibility
    const globalStarBackground = document.querySelector('.global-star-background');
    const makingAnImpactSection = document.querySelector('.making-an-impact');

    function updateStarVisibility(starBackground, section, footerElement) {
        if (!starBackground || !section || !footerElement) {
            console.log('Missing elements:', { starBackground, section, footer: footerElement });
            return;
        }

        const sectionRect = section.getBoundingClientRect();
        const footerRect = footerElement.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Show star if section has passed (top is above viewport) and footer hasn't entered yet
        const shouldShow = sectionRect.top < viewportHeight * 0.5 && footerRect.top > viewportHeight;

        console.log('Star visibility check:', {
            sectionTop: sectionRect.top,
            footerTop: footerRect.top,
            viewportHeight,
            shouldShow
        });

        if (shouldShow) {
            starBackground.classList.add('show');
            console.log('Star shown');
        } else {
            starBackground.classList.remove('show');
            console.log('Star hidden');
        }
    }

    if (globalStarBackground && makingAnImpactSection && footer) {
        // Update on scroll
        window.addEventListener('scroll', () => updateStarVisibility(globalStarBackground, makingAnImpactSection, footer));
        // Initial check
        updateStarVisibility(globalStarBackground, makingAnImpactSection, footer);
    }

    const whyJoinGroupSection = document.querySelector('.why-join-the-group');
    const qaSection = document.querySelector('.IN-section3');
    if (globalStarBackground && whyJoinGroupSection && qaSection) {
        // Update on scroll
        window.addEventListener('scroll', () => updateStarVisibility(globalStarBackground, whyJoinGroupSection, qaSection));
        // Initial check
        updateStarVisibility(globalStarBackground, whyJoinGroupSection, qaSection);
    }


    if (document.body.classList.contains('join-the-group-page')) {
        // 2. Select the Trigger Element (.IN-section4)
        const triggerElement = document.querySelector('.IN-section4');

        // 3. Select the Target Element to hide
        const targetElement = document.querySelector('.section-content--impact2 .background-sticky.impact-star-background');

        // Safety check: Ensure both elements exist before running logic
        if (triggerElement && targetElement) {

            // Define the logic function
            const toggleDisplay = () => {
                if (triggerElement.classList.contains('is-active')) {
                    targetElement.style.display = 'none';
                } else {
                    // Revert to default (usually block or flex) if is-active is removed
                    targetElement.style.display = '';
                }
            };

            // Run once immediately on load (in case it's active by default)
            toggleDisplay();

            // 4. Create an Observer to watch for class changes dynamically
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        toggleDisplay();
                    }
                });
            });

            // Start observing the trigger element for attribute changes
            observer.observe(triggerElement, {
                attributes: true,
                attributeFilter: ['class'] // Only listen for class changes
            });
        }
    }

    if (document.body.classList.contains('careers-page')) {
        const triggerElement = document.querySelector('.careers-photos');
        const targetElement = document.querySelector('.impact-star-background');

        if (triggerElement && targetElement) {
            const updateVisibility = () => {
                const rect = triggerElement.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                // Hide star if the photos section has entered the viewport
                if (rect.top < viewportHeight) {
                    targetElement.style.opacity = '0';
                    targetElement.style.visibility = 'hidden';
                    targetElement.style.transition = 'opacity 0.5s ease, visibility 0.5s ease';
                } else {
                    targetElement.style.opacity = '1';
                    targetElement.style.visibility = 'visible';
                }
            };

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(() => updateVisibility());
                },
                { threshold: 0.5 }
            );

            observer.observe(triggerElement);
            window.addEventListener('scroll', updateVisibility);
            updateVisibility();
        }
    }


    if (document.body.classList.contains('ourfuture-page')) {
        const triggerElement = document.querySelector('.section-content--future');

        // 3. Select the Target Element to hide
        const targetElement = document.querySelector('.section-content--future .background-sticky.impact-star-background');
        console.log(triggerElement.classList.contains('is-active'))
        // Safety check: Ensure both elements exist before running logic
        if (triggerElement && targetElement) {

            // Define the logic function
            const toggleDisplay = () => {
                if (triggerElement.classList.contains('is-active')) {
                    targetElement.style.display = 'none';
                } else {
                    // Revert to default (usually block or flex) if is-active is removed
                    targetElement.style.display = '';
                }
            };

            // Run once immediately on load (in case it's active by default)
            toggleDisplay();

            // 4. Create an Observer to watch for class changes dynamically
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        toggleDisplay();
                    }
                });
            });

            // Start observing the trigger element for attribute changes
            observer.observe(triggerElement, {
                attributes: true,
                attributeFilter: ['class'] // Only listen for class changes
            });
        }
    }

    function setupFadeInOnView() {
        const sections = document.querySelectorAll('.fade-section');

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const section = entry.target;
                        section.classList.add('visible');
                        obs.unobserve(section); // Optional: only animate once
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );

        sections.forEach((section) => observer.observe(section));
    }

    document.addEventListener('DOMContentLoaded', setupFadeInOnView);

    if (window.innerWidth >= 768) {
        const video = document.querySelector('.main-footer__media .video-wrapper');
        const trigger = document.querySelector('.main-footer');

        let isInView = false;

        const Observer = new IntersectionObserver(
            ([entry]) => {
                isInView = entry.isIntersecting;
                if (isInView) {
                    window.addEventListener('scroll', animateVideo);
                } else {
                    window.removeEventListener('scroll', animateVideo);
                    video.style.opacity = 0;
                    video.style.transform = 'translateY(100%)';
                }
            },
            { threshold: 0 }
        );

        Observer.observe(trigger);

        function animateVideo() {
            if (!isInView) return;

            const rect = trigger.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const progress = Math.min(Math.max((windowHeight - rect.top) / windowHeight, 0), 1);

            // Smooth animation using requestAnimationFrame
            requestAnimationFrame(() => {
                video.style.opacity = progress;
                video.style.transform = `translateY(${(1 - progress) * 100}%)`;

                if (progress > 0.95) {
                    video.parentElement.style.pointerEvents = 'auto';
                }
            });
        }
    }

    // window.addEventListener('scroll', function () {
    //   const scrolled = window.pageYOffset;
    //   const parallaxImage = document.querySelector('.parallax-img');
    //   parallaxImage.style.transform = 'translateY(' + scrolled * 0.1 + 'px)';
    // });

    function startCountUp(stat) {
        if (!stat.countup.error && !stat.isAnimated) {
            stat.countup.start();
            stat.isAnimated = true;
        }
    }

    var keyStatsArr = [];
    if (typeof CountUp !== 'undefined') {
        $('.inside-numbers h2 em, .inside-numbers.small-width h2 em').each(function (index, value) {
            var statTemp = {};
            statTemp.element = value;
            statTemp.isAnimated = false;
            var countupval = $(value)
                .text()
                .replace(/[^a-zA-Z0-9.]/g, '');
            console.log;
            var countType = countupval.indexOf('.') > -1 ? 'float' : '';
            countupval = countType === 'float' ? parseFloat(countupval) : parseInt(countupval);
            var countuptype = countType === 'float' ? 1 : 0;
            statTemp.countup = new CountUp(value, 0, isNaN(countupval) ? 0 : countupval, countuptype, 2);
            keyStatsArr.push(statTemp);
        });
    }

    if (typeof Waypoint !== 'undefined') {
        $(keyStatsArr).each(function (index, item) {
            new Waypoint({
                element: item.element,
                handler: function () {
                    startCountUp(item);
                },
                offset: 'bottom-in-view',
            });
        });
    }


    const stickySections = document.querySelectorAll('.sticky-heading');
    const stickyTop = Math.round(window.innerHeight * 0.125 * window.devicePixelRatio);
    const maxBlur = 5;

    function updateStickyHeadingEffects() {
        stickySections.forEach(section => {
            const sectionRect = section.getBoundingClientRect();
            const isSticky = Math.round(sectionRect.top * window.devicePixelRatio) >= stickyTop;

            // Get the content elements
            const contentElements = section.querySelectorAll('figure, img:not(figure img), h2, h3, p, .make-an-impact__header-content');

            if (isSticky) {
                // Find the next section that could overlap
                const nextSection = section.nextElementSibling;
                let opacity = 1;

                if (nextSection) {
                    const nextRect = nextSection.getBoundingClientRect();

                    // Calculate the bottom of the actual content (not including divider)
                    let contentBottom = sectionRect.top;
                    contentElements.forEach(element => {
                        const elementRect = element.getBoundingClientRect();
                        contentBottom = Math.max(contentBottom, elementRect.bottom);
                    });

                    const nextTop = nextRect.top;
                    const overlapDistance = contentBottom - nextTop;
                    const maxOverlap = 150; // Distance over which to fade

                    if (overlapDistance > 0) {
                        // Calculate fade based on overlap
                        const overlapRatio = Math.min(overlapDistance / maxOverlap, 1);
                        opacity = Math.max(1 - overlapRatio, 0);
                    }
                }

                // Apply effects
                contentElements.forEach(element => {
                    element.style.opacity = opacity;
                    element.style.filter = `blur(${(1 - opacity) * maxBlur}px)`;
                });
            } else {
                // Only reset to visible if section is ABOVE sticky position (scrolling back up)
                // Don't reset if section has scrolled PAST sticky position (scrolling down)
                if (sectionRect.top > stickyTop) {
                    contentElements.forEach(element => {
                        element.style.opacity = 1;
                        element.style.filter = 'blur(0px)';
                    });
                }
                // Don't change opacity when section is below sticky - keep it faded
            }
        });
    }

    // Update on scroll with throttling for performance
    // let scrollTimeout;
    // window.addEventListener('scroll', () => {
    //     if (scrollTimeout) {
    //         cancelAnimationFrame(scrollTimeout);
    //     }
    //     scrollTimeout = requestAnimationFrame(updateStickyHeadingEffects);
    // });


    let scrollTimeout;

    function scheduleUpdate() {
        if (scrollTimeout) {
            cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = requestAnimationFrame(updateStickyHeadingEffects);
    }

    // Scroll
    window.addEventListener('scroll', scheduleUpdate, { passive: true });

    // Resize → SAME effect as scroll
    window.addEventListener('resize', scheduleUpdate);

    // Initial update
    updateStickyHeadingEffects();

    // Initial update
    updateStickyHeadingEffects();



    function scaleListItemsOnScroll() {
        const listItems = document.querySelectorAll('li.relationships-list__people');

        function checkPositions() {
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            listItems.forEach((item, index) => {
                const rect = item.getBoundingClientRect();
                const isAtMidpoint = rect.top <= viewportHeight * 0.7 && rect.bottom >= viewportHeight * 0.6;

                if (isAtMidpoint) {
                    item.style.scale = '1.1';
                    item.style.transition = 'all 1s ease-in-out';
                } else {
                    item.style.scale = '1';
                }
            });
        }

        window.addEventListener('scroll', checkPositions);
        document.addEventListener('DOMContentLoaded', checkPositions);
    }

    scaleListItemsOnScroll();

    document.addEventListener('DOMContentLoaded', () => {
        const image = document.querySelector('#lottie-container');
        const header = document.querySelector('.relationships-header');
        const targetSection = document.querySelector('.unique-approach__content');

        let animationCompleted = false;
        let scrollStartPoint = 0;
        let headerReleased = false; // after natural position catches up, don't re-pin
        let sentinel; // placeholder to measure natural flow position and preserve space when pinned

        if (image) {
            image.classList.remove('visible');
            image.classList.remove('fade-out-on-scroll');
        }

        const OBSERVER = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const animation = lottie.loadAnimation({
                            container: document.getElementById('lottie-container'),
                            renderer: 'svg',
                            loop: false,
                            autoplay: true,
                            path: '/animation/Buidling-trust-1.json',
                        });
                        animation.setSpeed(1.5);
                        const animation1 = lottie.loadAnimation({
                            container: document.getElementById('lottie-container-text'),
                            renderer: 'svg',
                            loop: false,
                            autoplay: true,
                            path: '/animation/Building-trust-text.json',
                        });
                        animation1.setSpeed(1.5);
                        animation.addEventListener('complete', () => {
                            image.classList.add('visible');
                            animationCompleted = true;
                            scrollStartPoint = window.scrollY; // Capture current scroll position
                            // Create sentinel just before header to track its natural position

                            // Toggle "reveal-next" on the lottie image once the animation has completed and the user scrolls past the start point
                            (function () {
                                let revealListenerAdded = false;

                                function updateRevealNext() {
                                    if (!image) return;
                                    if (window.scrollY > scrollStartPoint) {
                                        image.classList.add('reveal-next');

                                    } else {
                                        image.classList.remove('reveal-next');
                                    }
                                }

                                // Add listener once animation completes
                                if (!revealListenerAdded) {
                                    window.addEventListener('scroll', updateRevealNext);
                                    // Run once to set initial state
                                    updateRevealNext();
                                    revealListenerAdded = true;
                                }
                            })();
                            if (header && !sentinel) {
                                sentinel = document.createElement('div');
                                sentinel.className = 'relationships-header-sentinel';
                                sentinel.style.height = '0px';
                                header.parentNode.insertBefore(sentinel, header);
                            }
                        });

                        OBSERVER.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );

        if (targetSection) {
            OBSERVER.observe(targetSection);
        }

        window.addEventListener('scroll', () => {
            if (!animationCompleted) return;

            const scrollAmount = window.scrollY;

            // Start fade-out of lottie and fade/scale-in of header at same threshold
            const revealThreshold = scrollStartPoint + 200; // tune if needed

            console.log(revealThreshold)
            if (scrollAmount > revealThreshold) {
                image.classList.add('fade-out-on-scroll');
                header.classList.add('visible');
                // Only pin if we haven't released into normal flow yet
                if (!headerReleased) {
                    header.classList.add('is-pinned');
                    // Reserve space so layout doesn't jump while fixed
                    if (sentinel) {
                        const h = header.offsetHeight;
                        if (h > 0) sentinel.style.height = h + 'px';
                    }
                }
            } else {
                image.classList.remove('fade-out-on-scroll');
                header.classList.remove('visible');
                header.classList.remove('is-pinned');
                // Reset state and spacer when scrolling back above threshold
                headerReleased = false;
                if (sentinel) sentinel.style.height = '0px';
            }

            // Release header back to normal flow once its original top crosses the pinned line
            if (header.classList.contains('visible') && header.classList.contains('is-pinned')) {
                const pinnedLine = window.innerHeight * 0.2; // matches CSS top: 20%
                if (sentinel) {
                    const sentinelTop = sentinel.getBoundingClientRect().top;
                    if (sentinelTop <= pinnedLine) {
                        header.classList.remove('is-pinned');
                        headerReleased = true;
                        // Remove spacer height now that header is back in flow
                        sentinel.style.height = '0px';
                    }
                }
            }
        });
    });

    // Wait for the Lottie SVG to be rendered, then set background path fill to transparent
    function setLottieBackgroundTransparent() {
        const background = document.querySelector('#lottie-container > svg > g > g:nth-child(1) > g > path');
        if (background) {
            background.setAttribute('fill', 'transparent');
            document.querySelector('#__lottie_element_40 > g > path').setAttribute('fill', 'transparent');
        }
        setTimeout(setLottieBackgroundTransparent, 50);
    }
    // setLottieBackgroundTransparent();

    lottie.loadAnimation({
        container: document.getElementById('lottie-container-star'), // Where to render
        renderer: 'svg', // SVG is scalable and sharp
        loop: false, // Change to false if you only want it to play once
        autoplay: true, // Start automatically
        path: '/animation/star-bust.json', // Path to the JSON animation file
    });

    lottie.loadAnimation({
        container: document.getElementById('lottie-container-star1'), // Where to render
        renderer: 'svg', // SVG is scalable and sharp
        loop: false, // Change to false if you only want it to play once
        autoplay: true, // Start automatically
        path: '/animation/star-bust.json', // Path to the JSON animation file
    });

    gsap.to(".section-banner--story", {
        y: "350",
        ease: "linear",
        scrollTrigger: {
            trigger: ".section-banner--story",
            markers: false,
            start: "0%",
            end: "bottom 0%",
            scrub: 0
        }
    });

    gsap.to(".section-banner--future", {
        y: "350",
        ease: "linear",
        scrollTrigger: {
            trigger: ".section-banner--future",
            markers: false,
            start: "0%",
            end: "bottom 0%",
            scrub: 0
        }
    });

    // Star rotation on scroll for homepage
    gsap.to(".insights-banner .background-fixed__star-bg-blue", {
        rotation: 25,
        ease: "linear",
        scrollTrigger: {
            trigger: ".insights-banner",
            markers: false,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    gsap.to(".insights-banner .background-fixed__star-bg img", {
        rotation: 25,
        ease: "linear",
        scrollTrigger: {
            trigger: ".insights-banner",
            markers: false,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    // Star rotation on scroll for our-impact page
    gsap.to(".impact-star-background img", {
        rotation: 45,
        transformOrigin: "center center",
        ease: "linear",
        scrollTrigger: {
            trigger: ".section-content--impact2",
            markers: false,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });
    // Star rotation on scroll for culture page
    gsap.to(".culture-star-background img", {
        rotation: 45,
        transformOrigin: "center center",
        ease: "linear",
        scrollTrigger: {
            trigger: ".section-content--impact2",
            markers: false,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    // Star rotation on scroll for our-story page
    gsap.to(".section-platform .background-sticky img", {
        rotation: 45,
        transformOrigin: "center center",
        ease: "linear",
        scrollTrigger: {
            trigger: "main",
            markers: false,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    gsap.to(".our-thinking-banner .background-fixed__star-bg img", {
        rotation: 35,
        ease: "linear",
        scrollTrigger: {
            trigger: ".our-thinking-banner",
            markers: false,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    // Star rotation on scroll for Who We Are page (section-purpose)
    gsap.to(".section-purpose .fixed-star img", {
        rotation: 25,
        ease: "linear",
        scrollTrigger: {
            trigger: ".section-purpose",
            markers: false,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    if (typeof SplitText !== "undefined") {
        gsap.registerPlugin(SplitText);
        gsap.registerPlugin(ScrollTrigger);
    } else {
        console.error("SplitText plugin is not loaded. Please include it in your project.");
    }

    let splitElements = [];

    function setupSplitTextAnimations() {
        // Clean up previous splits
        splitElements.forEach(split => {
            if (split) split.revert();
        });
        splitElements = [];

        document.fonts.ready.then(() => {
            // Find all split text elements
            const splitTextElements = document.querySelectorAll(".split");

            if (splitTextElements.length === 0) {
                return;
            }

            splitTextElements.forEach((element, index) => {
                // Create split for each element
                const split = SplitText.create(element, {
                    type: "words,lines",
                    linesClass: "line"
                });

                splitElements.push(split);

                // Set initial state - hide the lines with overflow:hidden on parent
                gsap.set(element, {
                    opacity: 1,
                    overflow: "hidden"
                });

                gsap.set(split.lines, {
                    yPercent: 100,
                    opacity: 0
                });

                // Check if element is inside a sticky container
                const stickyParent = element.closest('.make-an-impact__header, .sticky-heading');
                const isInImpactHeaderContent = element.closest('.make-an-impact__header-content');

                // For make-an-impact__header-content, use the content div itself as trigger with later timing
                let triggerElement, startPosition;
                if (isInImpactHeaderContent) {
                    triggerElement = isInImpactHeaderContent;
                    startPosition = "top 70%"; // Trigger when content div reaches 70% down the viewport
                } else {
                    triggerElement = stickyParent ? stickyParent.closest('section') || stickyParent.parentElement : element;
                    startPosition = stickyParent ? "top 50%" : "top 90%";
                }

                // Create ScrollTrigger for this specific element
                ScrollTrigger.create({
                    trigger: triggerElement,
                    start: startPosition,
                    once: true, // Only animate once
                    onEnter: () => {
                        gsap.to(split.lines, {
                            duration: 1,
                            yPercent: 0,
                            opacity: 1,
                            stagger: 0.1,
                            ease: "expo.out",
                            delay: isInImpactHeaderContent ? 0.3 : 0, // Add slight delay for impact header content
                            onComplete: () => {
                                // Remove overflow hidden after animation completes
                                gsap.set(element, { overflow: "visible" });
                            }
                        });
                    }
                });
            });
        });
    }

    // Initial setup
    setupSplitTextAnimations();

    // Re-split and animate on resize
    window.addEventListener("resize", () => {
        setupSplitTextAnimations();
    });

    // Fade out our-thinking banner content when it touches the logo (similar to our-story)
    gsap.fromTo(".our-thinking-banner__content",
        {
            opacity: 1 // Start fully visible
        },
        {
            opacity: 0, // Fade to invisible
            ease: "linear",
            scrollTrigger: {
                trigger: ".our-thinking-banner h2", // Target the h2 "Lead Through Change" element (main heading like h1 in our-story)
                markers: false,
                start: "top 250px", // Start fading when h2 reaches 80px from top (logo position)
                end: "top 10px", // Complete fade by this point
                scrub: 0
            }
        }
    );


    const bodyClass = document.querySelector('.ourimpact-page');
    if (bodyClass) {
        const video = document.querySelector('.global-video__media');
        const lastSection = document.querySelector('.impact-slider');

        let lastScrollY = window.scrollY;

        const _observer = new IntersectionObserver(

            ([entry]) => {
                const currentScrollY = window.scrollY;
                const scrollingUp = currentScrollY < lastScrollY;

                if (entry.isIntersecting) {
                    video.classList.add('fixed');
                } else if (scrollingUp) {
                    video.classList.remove('fixed');
                }

                lastScrollY = currentScrollY;
            },
            {
                root: null,
                threshold: 0.1,
            }
        );
        _observer.observe(lastSection);

        // Control impact star background visibility - hide when unique-approach section comes into view and keep hidden for all sections below
        const uniqueApproachSection = document.querySelector('.unique-approach');
        const impactStarBackground = document.querySelector('.impact-star-background');

        if (uniqueApproachSection && impactStarBackground) {
            // Initially show the star background
            impactStarBackground.style.opacity = '1';
            impactStarBackground.style.visibility = 'visible';

            // Function to check if we should hide the star (unique-approach or any section below it is visible)
            function shouldHideImpactStar() {
                const uniqueApproachRect = uniqueApproachSection.getBoundingClientRect();
                const viewportHeight = window.innerHeight;

                // Hide star if unique-approach section has entered the viewport (top is above viewport bottom)
                return uniqueApproachRect.top < viewportHeight;
            }

            // Function to update star visibility
            function updateImpactStarVisibility() {
                if (shouldHideImpactStar()) {
                    impactStarBackground.style.opacity = '0';
                    impactStarBackground.style.visibility = 'hidden';
                } else {
                    impactStarBackground.style.opacity = '1';
                    impactStarBackground.style.visibility = 'visible';
                }
            }

            // Observer for unique-approach section
            const uniqueApproachObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        updateImpactStarVisibility();
                    });
                },
                { threshold: 0.1 }
            );

            uniqueApproachObserver.observe(uniqueApproachSection);

            // Also add scroll listener for more responsive updates
            let scrollTimeout;
            window.addEventListener('scroll', function () {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(updateImpactStarVisibility, 50); // Debounce scroll updates
            });
        }

        //star animation on scroll
        const container = document.getElementById('lottieContainer12');
        const animation = lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: true, // Set loop to false as we will control it manually
            autoplay: false, // Set autoplay to false to control animation with scroll
            path: '/animation/PCStar03.json'
        });

        window.addEventListener('scroll', () => {
            const scrollTop = window.scrollY;
            const speedFactor = 2; // Number of loops per full scroll
            const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollProgress = scrollTop / scrollHeight;

            const totalFrames = animation.totalFrames;
            const frame = Math.floor((scrollProgress * totalFrames * speedFactor) % totalFrames);

            animation.goToAndStop(frame, true);
        });

        // window.addEventListener('scroll', () => {
        //     const scrollTop = window.scrollY;
        //     const rotation = (scrollTop * 0.1) % 360;
        //     container.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
        // });
    }

    const cultureClass = document.querySelector('.culture-page');

    if (cultureClass) {
        // Control culture star background visibility - hide when section2 section comes into view and keep hidden for all sections below
        const section2 = document.querySelector('.CU-section2');
        const cultureStarBackground = document.querySelector('.culture-star-background');

        if (section2 && cultureStarBackground) {
            // Initially show the star background
            cultureStarBackground.style.opacity = '1';
            cultureStarBackground.style.visibility = 'visible';

            // Function to check if we should hide the star (section2 or any section below it is visible)
            function shouldHideCultureStar() {
                const section2Rect = section2.getBoundingClientRect();
                const viewportHeight = window.innerHeight;

                // Hide star if section2 section has entered the viewport (top is above viewport bottom)
                return section2Rect.top < viewportHeight;
            }

            // Function to update star visibility
            function updateCultureStarVisibility() {
                if (shouldHideCultureStar()) {
                    cultureStarBackground.style.opacity = '0';
                    cultureStarBackground.style.visibility = 'hidden';
                } else {
                    cultureStarBackground.style.opacity = '1';
                    cultureStarBackground.style.visibility = 'visible';
                }
            }

            // Observer for section2 section
            const section2Observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        updateCultureStarVisibility();
                    });
                },
                { threshold: 0.1 }
            );

            section2Observer.observe(section2);

            // Also add scroll listener for more responsive updates
            let scrollTimeout;
            window.addEventListener('scroll', function () {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(updateCultureStarVisibility, 50); // Debounce scroll updates
            });
        }
    }
    const investorPage = document.querySelector('.investor-page');
    if (investorPage) {
        if (screen.width >= 992) {
            let containerWidth = document.querySelector('.scroll-card-list').offsetWidth;
            //console.log("Scroll card list width (container) : "+containerWidth);

            var element = document.querySelector('.scroll-card-list');
            var totalBox = element.children.length;
            //console.log("Total Scroll Card : "+totalBox);

            let boxWidth = document.querySelector('.scroll-card').offsetWidth;
            //console.log("Scroll Card width : "+boxWidth);

            let p = document.querySelector('.scroll-card');
            let boxMarginRight = p.currentStyle || window.getComputedStyle(p);
            boxMarginRight = boxMarginRight.marginRight.replace("px", "");
            //console.log("Scroll Card Margin : "+boxMarginRight);

            let boxImgWidth = document.querySelector('.scroll-card-img').offsetWidth;
            //console.log("Scroll Card Img width : "+boxImgWidth);

            let totalWidth = ((totalBox * boxImgWidth) + (boxMarginRight * (totalBox - 1))) - 400;
            //console.log(totalWidth);

            let tranfromX = containerWidth - totalWidth;
            // const tranfromX = "-300%"

            // First Section animation
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: "#scroll-card",
                    start: 'top top',
                    end: "+=350%",
                    markers: false,
                    scrub: 0.5,
                    pin: true,
                    pinSpacing: 575,
                    invalidateOnRefresh: true,
                },
            });
            tl.fromTo("#scroll-card .scroll-card-list", { x: "0%" }, { x: tranfromX, }, 'start')
            let tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: "#scroll-card",
                    start: 'top top',
                    end: "+=350%",
                    scrub: 0.5
                },
            });
            // tl2.fromTo("#scroll-card .scroll-card-list .scroll-card", { width: boxWidth, paddingLeft: 0 + "px" }, { width: boxImgWidth + "px", paddingLeft: "0", stagger: 1 }, 'start')
            //     .fromTo("#scroll-card .scroll-card-list .scroll-card-content h3", { webkitTextStrokeColor: "#829496" }, { webkitTextStrokeColor: "#75DAB4", stagger: 1, }, 'start')
            //     .fromTo("#scroll-card .scroll-card-list .scroll-card-content h5", { color: "#829496" }, { color: "#75DAB4", stagger: 1, }, 'start')
            //     .fromTo("#scroll-card .scroll-card-list .scroll-card-content p", { color: "#000" }, { color: "#ffffff", stagger: 1, }, 'start')
            //     .fromTo("#scroll-card .scroll-card-list .scroll-card-content a", { color: "#000" }, { color: "#ffffff", stagger: 1, }, 'start');
        }
    }



    // const scrollContainer = document.querySelector(".scroll-card-list");

    // scrollContainer.addEventListener("wheel", (evt) => {
    //     evt.preventDefault();
    //     scrollContainer.scrollLeft += evt.deltaY;
    // });

    function initUniqueApproachScroll() {
        const section = document.querySelector('.scrolly-section');
        if (!section) return;

        const stickyContent = section.querySelector('.sticky-content');

        function handleScroll() {
            const rect = section.getBoundingClientRect();
            const sectionHeight = section.offsetHeight;
            const windowHeight = window.innerHeight;

            let progress = (windowHeight - rect.top) / (sectionHeight + windowHeight);
            progress = Math.max(0, Math.min(1, progress));

            // --- TIMING ---
            // 0.00 - 0.20: Start (Title Only)
            // 0.20 - 0.40: Paragraphs
            // 0.40 - 0.60: Star Image
            // 0.60 - 0.80: Final P
            // 0.80 - 1.00: Final H3

            if (progress < 0.20) {
                stickyContent.setAttribute('data-step', '0');
            } else if (progress >= 0.20 && progress < 0.40) {
                stickyContent.setAttribute('data-step', '1');
            } else if (progress >= 0.40 && progress < 0.60) {
                stickyContent.setAttribute('data-step', '2');
            } else if (progress >= 0.60 && progress < 0.80) {
                stickyContent.setAttribute('data-step', '3');
            } else {
                stickyContent.setAttribute('data-step', '4');
            }
        }

        window.addEventListener('scroll', handleScroll);
        handleScroll();
    }


    if (document.body.classList.contains('ourimpact-page')) {
        initUniqueApproachScroll();
    }



});
